import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../helpers/config.service';
import { TokenStorageService } from '../services/token-storage.service'

@Injectable({
  providedIn: 'root'
})

export class MenuService {

  constructor(private config: ConfigService, private http:  HttpClient, private tokenstorge: TokenStorageService) { }


   getmenu(): Observable<any>{
    console.log("se menu");
    let token = this.tokenstorge.getToken();

     console.log(token);
     
    let httpOptions = {
      headers: new HttpHeaders({'Authorization': 'Bearer '+token})
      };
    
     // aqui preparamos poara la cabecer
   return this.http.get(this.config.phat+'getMenu', httpOptions);
   }
}
